import { render, staticRenderFns } from "./licencePlateModule.vue?vue&type=template&id=37a5cc59"
import script from "./licencePlateModule.vue?vue&type=script&lang=js"
export * from "./licencePlateModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./licencePlateModule.vue?vue&type=style&index=0&id=37a5cc59&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports